"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.LINKS_CAROUSEL_TITLE = exports.LINKS_CAROUSEL_ROOT = exports.LINKS_CAROUSEL_ID = exports.CAROUSEL_TABLET_WIDTH = exports.CAROUSEL_SM_BREAKPOINT = exports.CAROUSEL_MOBILE_WIDTH = exports.CAROUSEL_DESKTOP_WIDTH = exports.CAROUSEL_BIG_TABLET_WIDTH = void 0;
const LINKS_CAROUSEL_TITLE = exports.LINKS_CAROUSEL_TITLE = 'links-carousel-title';
const LINKS_CAROUSEL_ROOT = exports.LINKS_CAROUSEL_ROOT = 'links-carousel-root';
const LINKS_CAROUSEL_ID = exports.LINKS_CAROUSEL_ID = 'editorials-links-carousel';
const CAROUSEL_DESKTOP_WIDTH = exports.CAROUSEL_DESKTOP_WIDTH = '1184px';
const CAROUSEL_BIG_TABLET_WIDTH = exports.CAROUSEL_BIG_TABLET_WIDTH = '824px';
const CAROUSEL_TABLET_WIDTH = exports.CAROUSEL_TABLET_WIDTH = '728px';
const CAROUSEL_MOBILE_WIDTH = exports.CAROUSEL_MOBILE_WIDTH = '330px';
const CAROUSEL_SM_BREAKPOINT = exports.CAROUSEL_SM_BREAKPOINT = '768px';
